import { SET_CURRENT_STORE, SET_CURRENT_STORE_ID_AND_ZIPCODE } from '../actions/actionTypes';
import getThdStore from '../utils/getThdStoreInfo';

const { zipcode = 30339, storeNumber = '0121', isStoreEnabled = true } = getThdStore() || {};
const initialState = {
  isStoreEnabled,
  storeNumber,
  zipcode,
  storeInfo: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
  case SET_CURRENT_STORE: {
    return {
      ...state,
      isStoreEnabled: action.payload.isStoreEnabled,
      storeNumber: Number(action.payload.storeId),
      zipcode: Number(action.payload.zipcode),
      storeInfo: action.payload.storeInfo,
      previousStoreNumber: state.storeInfo?.storeId,
    };
  }
  case SET_CURRENT_STORE_ID_AND_ZIPCODE: {
    return {
      ...state,
      isStoreEnabled: action.payload.isStoreEnabled,
      storeNumber: Number(action.payload.storeId),
      zipcode: Number(action.payload.zipcode),
      previousStoreNumber: state.storeInfo?.storeId,
    };
  }

  default:
    return state;
  }
};